import React, { Component } from 'react'
import { Card } from 'react-bootstrap'
import { Button } from '@material-ui/core'
import * as actions from '../../actions'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { FORM_CUPO } from '../../../../config/forms'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { parseEntityId } from '../../../../models/entity'
import {
  TABLA_CORREOS_UPDATE
} from '../../../../config/tables'

class DialogoCorreoUpdate extends Component {
  async componentDidMount () {
    const {
      exportador
    } = this.props
    this.props.actualizarCorreosMuiTable(parseEntityId(exportador))
  }

  render () {
    const {
      handleClose,
      exportador
    } = this.props

    return (
      <div>
        <Card style={{ border: 'none' }}>
          <Card.Header style={{ backgroundColor: '#3f51b5', color: '#ffffff' }}>
            <Card.Text style={{ fontSize: '1.3rem', textAlign: 'center' }}>Contactos de {exportador}</Card.Text>
          </Card.Header>
          <Card.Body>
            <MuiTable id={TABLA_CORREOS_UPDATE} />
          </Card.Body>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              style={{ margin: '2%' }}
              onClick={handleClose}
              size='medium'
              variant='contained'
              color='primary'
            >Cerrar</Button>
          </div>
        </Card>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    exportador: state.cupos.exportador,
    openAddCorreo: state.cupos.openAddCorreo
  }
}

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_CUPO,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(DialogoCorreoUpdate))
